import { render, staticRenderFns } from "./UserDailyInvestment.vue?vue&type=template&id=754e6430&scoped=true"
import script from "./UserDailyInvestment.vue?vue&type=script&lang=js"
export * from "./UserDailyInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754e6430",
  null
  
)

export default component.exports